<template>
  <v-dialog v-model="showDialog" width="600px">
    <v-card>
      <v-toolbar class="primary dark">
        <v-spacer></v-spacer>
        <v-btn color="white" text @click="showDialog = false"> Fechar </v-btn>
      </v-toolbar>
      <v-card-title>
        <span class="headline"> Lançamento de despesas manuais</span>
      </v-card-title>
      <v-progress-circular
        v-show="loading"
        indeterminate
        color="white"
      ></v-progress-circular>

      <v-card-text v-show="!loading">
        <v-simple-table>
          <thead>
            <tr>
              <th class="subheading font-weight-light text-center">CtpCod</th>
              <th class="subheading font-weight-light text-center">
                Descrição
              </th>
              <th class="subheading font-weight-light text-center">Valor</th>
            </tr>
          </thead>
          <tbody class="text-center">
            <tr v-for="(item, index) in items" :key="index">
              <td>
                <v-text-field
                  class="pa-2 ma-2"
                  :disabled="!editable"
                  label="Código"
                  v-model.number="item.ctpCod"
                ></v-text-field>
              </td>
              <td>
                {{ item.description }}
              </td>
              <td>
                <v-currency-field
                  label="Valor"
                  prefix="R$"
                  class="mx-2"
                  style="font-size: 14px"
                  filled
                  rounded
                  dense
                  solo
                  :disabled="!editable"
                  v-model="item.tsdMnyValor"
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>Total</td>
              <td><span v-money-format="fin129Total()"></span></td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions
        v-if="
          itemSelected.fin129s?.filter((el) => el.stageSlug == stageSlug)
            ?.length > 0
        "
      >
        <p>Despesas cadastradas</p>
      </v-card-actions>

      <v-card-actions v-else>
        <v-spacer></v-spacer>
        <v-btn
          class="primary"
          color="white"
          text
          v-if="editable"
          :disabled="posting"
          @click="postFin129(itemSelected)"
        >
          <v-progress-circular
            v-show="posting"
            indeterminate
            color="white"
          ></v-progress-circular>
          Cadastrar lançamento
        </v-btn>
      </v-card-actions>

      <v-card-text v-if="fin129.owner?.username">
        <p>
          Criado por {{ fin129.owner?.username }} em
          <span v-datetime-format="fin129.createdAt"></span>
        </p>

        <p>Código conexos: {{ fin129.tnsCod }}</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import strapiApi from "../../../../libraries/strapi/strapiApi";
import VCurrencyField from "../../components/VCurrencyField.vue";

export default {
  name: "dialog-fin129",
  components: {
    VCurrencyField,
  },
  props: ["value", "itemSelected", "tabs", "stageSlug"],
  data() {
    return {
      files: [],
      selectedFile: null,
      base64Data: "",
      loading: false,
      posting: false,
      comment: "",
      despesas: {},
      fin129: {
        priCod: 50,
        tnsDatTrasnf: 1744848000000,
        filCod: 3,
        gerNum: 832,
        tnsMnyValor: 2000,
        tnsVldCobrJur: 0,
        tnsVldTipo: 3,
        tnsVldTpOpr: 1,
      },
      items: [],
      editable: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    availableTabs() {
      if (
        this.itemSelected?.processStage?.slug == "financeiro" ||
        this.itemSelected?.processStage?.slug == "contabil"
      ) {
        return this.tabs?.filter(
          (el) => el?.slug !== "financeiro" && el?.slug !== "contabil"
        );
      } else {
        return this.tabs?.filter(
          (el) =>
            el?.slug !== this.itemSelected?.processStage?.slug &&
            el?.slug !== "contabil"
        );
      }
    },
  },
  methods: {
    closeModal() {
      this.showDialog = false;
    },

    fin129Total() {
      return this.items
        ?.filter((el) => el.ctpCod)
        .reduce((acc, curr) => acc + curr.tsdMnyValor, 0);
    },

    async postFin129(item) {
      this.posting = true;
      try {
        if (this.fin129Total()) {
          let today = new Date();

          //tests
          today.setMonth(today.getMonth() - 1);

          let fin129 = {
            priCod: this.itemSelected.PRI_COD,
            tnsDatTrasnf: new Date(
              today.toISOString().substring(0, 10)
            ).getTime(),
            filCod: this.itemSelected.FIL_COD,
            gerNum: 832,
            tnsMnyValor: Math.round(this.fin129Total() * 100) / 100,
            tnsVldCobrJur: 0,
            tnsVldTipo: 3,
            tnsVldTpOpr: 1,
            owner: this.user.id,
            stageSlug: this.stageSlug,

            items: [],
          };

          for (let i = 0; i < this.items.length; i++) {
            let item = this.items[i];
            let fin129Item = {
              // "ungDesNome": "IMPORTAÇÃO",
              ungCod: 9,
              prjCod: 2,
              ctpCod: item.ctpCod,
              // "ctpDesNome": "HONORARIOS DESPACHANTE",
              priCod: this.itemSelected.PRI_COD,
              filCod: this.itemSelected.FIL_COD,
              //tnsCod: ans?.tnsCod,
              tnsVldTipo: 3,
              tsdMnyValor: item.tsdMnyValor,
              description: item.description,
            };

            fin129.items.push(fin129Item);
          }

          let ansFin129 = await strapiApi.fin129.createFin129(fin129);

          let processToUpdate = {
            id: this.itemSelected.id,
            tnsCod: ansFin129?.tnsCod,
          };
          this.$emit("doProcessUpdate", processToUpdate);
        } else {
          alert("Sem despesas a lançar");
        }
      } catch (error) {
        alert(`Error: ${error}`);
      }

      this.posting = false;
    },

    async getData() {
      this.items = [];
      this.fin129 = {};
      this.loading = true;
      let filters = {
        filCod: { eq: this.itemSelected.FIL_COD },
        priCod: { eq: this.itemSelected.PRI_COD },
        stageSlug: { eq: this.stageSlug },
      };

      let { values, pagination } = await strapiApi.fin129.getWithPagination(
        1,
        1,
        "id",
        true,
        filters
      );

      let items = [];
      if (values?.length > 0) {
        let fin129 = values[0];
        this.fin129 = fin129;
        items = fin129.fin129items;
        this.items = items;
        this.editable = false;
        this.loading = false;
        return;
      }

      if (this.stageSlug == "operacional") {
        //check despesas
        filters = {
          FIL_COD: { eq: this.itemSelected.FIL_COD },
          PRI_COD: { eq: this.itemSelected.PRI_COD },
        };

        ({ values, pagination } =
          await strapiApi.vwFechProcDespesas.getWithPagination(
            1,
            1,
            "id",
            true,
            filters
          ));

        let despesas;
        if (values?.[0]) {
          despesas = values[0];
          this.despesas = values[0];
        }

        items.push({
          ctpCod: despesas?.CTA_PROJETO_HON_DESPACHANTE,
          description: "Honorários despachante",
          tsdMnyValor: despesas?.VL_LANCAR_HON_DESPACHANTE ?? 0,
        });

        items.push({
          ctpCod: despesas?.CTA_PROJETO_TX_EXPEDIENTE,
          description: "Taxa expediente",
          tsdMnyValor: despesas?.VL_LANCAR_TAXA_EXPEDIENTE ?? 0,
        });

        items.push({
          ctpCod: despesas?.CTA_PROJETO_AVERB_SEGURO,
          description: "Averbação de seguro",
          tsdMnyValor: despesas?.VL_LANCAR_AVERB_SEGURO ?? 0,
        });

        items.push({
          ctpCod: despesas?.CTA_PROJETO_CORRET_CAMBIO,
          description: "Corretagem de câmbio",
          tsdMnyValor: despesas?.VL_LANCAR_CORRET_CAMBIO ?? 0,
        });
      } else {
        items.push({
          ctpCod: 1756,
          description: "Baixa de processo",
          tsdMnyValor: 0,
        });
      }

      this.items = items;
      this.editable = true;

      this.loading = false;
    },
  },
  watch: {
    showDialog(val) {
      if (val) {
        this.getData();
      }
    },
  },
};
</script>
